import React, { useEffect, useRef } from 'react';

export const AccessibleErrorContainer = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref.current]);
  return (
    <div role="alert" ref={ref}>
      {children}
    </div>
  );
};
